var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"portal","dark":_vm.darkTheme}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('router-view'),_c('snackbar'),(_vm.isLoggedIn)?_c('session-notice-modal'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }